import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import adminApi, { setAdminToken } from "@/lib/adminApi";
import BrandMark from "@/components/BrandMark";
import Footer from "@/components/Footer";
import { LogOut, Settings } from "lucide-react";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [{ data: me }, { data: s }] = await Promise.all([
          adminApi.get("/me"),
          adminApi.get("/dashboard"),
        ]);
        setAdmin(me);
        setStats(s);
      } catch {
        navigate("/admin/login", { replace: true });
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate]);

  const logout = async () => {
    try { await adminApi.post("/logout"); } catch {}
    setAdminToken(null);
    navigate("/admin/login", { replace: true });
  };

  if (loading) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-[#FBF9F6] grain">
        <div className="text-xs uppercase tracking-[0.3em] text-stone-400">Loading</div>
      </div>
    );
  }

  return (
    <div className="min-h-[100dvh] bg-[#FBF9F6] grain">
      <div className="max-w-2xl mx-auto px-6 pt-12 pb-12">
        <BrandMark className="mb-6" to="/admin/dashboard" />
        <div className="flex items-start justify-between mb-8">
          <div>
            <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-[#6B7A54]">
              Admin
            </div>
            <h1 className="font-[Cormorant_Garamond] text-4xl leading-tight tracking-tight text-stone-900">
              Dashboard
            </h1>
            <p className="text-sm font-[Manrope] text-stone-600 mt-1">{admin?.email}</p>
          </div>
          <div className="flex gap-2">
            <Link to="/admin/settings" data-testid="admin-settings-link" className="h-10 px-4 rounded-full border border-stone-300 flex items-center gap-2 text-sm font-[Manrope]">
              <Settings size={14} strokeWidth={1.5} /> Settings
            </Link>
            <button data-testid="admin-logout-btn" onClick={logout} className="h-10 px-4 rounded-full bg-stone-900 text-white flex items-center gap-2 text-sm font-[Manrope]">
              <LogOut size={14} strokeWidth={1.5} /> Sign out
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats && Object.entries({
            "Users": stats.users,
            "Onboarded": stats.onboarded,
            "Closet items": stats.closet_items,
            "Events": stats.events,
            "Suggestions": stats.outfit_suggestions,
          }).map(([k, v]) => (
            <div key={k} className="bg-white border border-stone-100 rounded-2xl p-5">
              <div className="text-[10px] font-[Manrope] font-bold tracking-[0.25em] uppercase text-stone-500">{k}</div>
              <div className="font-[Cormorant_Garamond] text-4xl text-stone-900 mt-1">{v}</div>
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
}
